<template>
  <div
    :class="
      'customer-place-order-view ' +
        (typeof license !== 'undefined' ? license.licenseHash : '')
    "
  >
    <!-- LOGIN MODAL -->
    <auth-modal
      v-if="showLoginModal"
      :lang="lang"
      :order="order"
      @close="handleAuthClose"
    ></auth-modal>
    <div
      v-if="loading"
      class="wg-row"
      style="align-items: center; justify-content: center; margin-top: 20px"
    >
      <vue-simple-spinner
        size="medium"
        :line-fg-color="appColor"
      ></vue-simple-spinner>
    </div>
    <template v-if="!loading">
      <!-- LOADING MODAL -->
      <wg-modal :simple="true" :width="'200px'" v-if="updating">
        <template slot="body">
          <div
            class="wg-row com-anm22-app-text-l"
            style="justify-content: center"
          >
            {{ $anm22.strLang(lang, "Loading...", "Elaborazione in corso...") }}
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
          <div
            class="wg-row"
            style="align-items: center; justify-content: center"
          >
            <vue-simple-spinner
              size="medium"
              :line-fg-color="appColor"
            ></vue-simple-spinner>
          </div>
        </template>
      </wg-modal>
      <!-- MODALE PER VERIFICA SLOT TEMPORALE -->
      <wg-modal
        simple
        :width="windowWidth > 600 ? '600px' : '90%'"
        v-if="showDeliveryTimeModal"
        @closeModal="showDeliveryTimeModal = false"
      >
        <div slot="body" class="wg-row">
          <template v-if="checkingSlot">
            <div
              class="wg-row"
              style="
                align-items: center;
                justify-content: center;
                margin-top: 20px;
              "
            >
              <vue-simple-spinner
                size="medium"
                :line-fg-color="appColor"
              ></vue-simple-spinner>
            </div>
            <div
              class="wg-row"
              style="
                justify-content: center;
                text-align: center;
                margin-top: 20px;
              "
            >
              <div class="com-anm22-app-text-xl">
                {{
                  $anm22.strLang(
                    lang,
                    "Checking if this time slot is available...",
                    "Sto controllando se l'orario di consegna è disponibile..."
                  )
                }}
              </div>
            </div>
          </template>
          <div
            v-else
            class="wg-row"
            style="
              flex-direction: column;
              flex-wrap: nowrap;
              align-items: center;
              text-align: center;
            "
          >
            <div
              class="com-anm22-app-text-xl"
              style="color: red; margin-top: 20px"
            >
              {{
                $anm22.strLang(
                  lang,
                  "The time selected is not available, please try another one.",
                  "L'orario scelto non è disponibile, selezionarne un altro."
                )
              }}
            </div>
            <div
              v-for="(cat, i) in slotOccupiedCat"
              :key="'cat-occupied-' + i"
              class="com-anm22-app-text-l"
              style="margin-top: 20px"
            >
              {{
                $anm22.strLang(
                  lang,
                  "Products of category " +
                    cat.name +
                    " are not available for ordering before " +
                    cat.avail_time +
                    ".",
                  "I prodotti della categoria " +
                    cat.name +
                    " non sono disponibili all'ordinazione prima di " +
                    cat.avail_time +
                    "."
                )
              }}
            </div>
            <button
              class="small"
              @click="showDeliveryTimeModal = false"
              style="margin-top: 20px"
            >
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Continue", "Continua") }}
              </div>
            </button>
          </div>
        </div>
      </wg-modal>
      <!-- MODALE PER TERMINI SERVIZIO -->
      <wg-modal
        :width="windowWidth > 900 ? '900px' : '90%'"
        v-if="showTermsModal"
        @closeModal="showTermsModal = false"
      >
        <div slot="header">
          {{
            $anm22.strLang(lang, "Terms of agreement", "Termini e condizioni")
          }}
        </div>
        <div slot="body" class="wg-row">
          <div class="wg-row">
            {{ license.termsText }}
          </div>
        </div>
      </wg-modal>
      <!-- MODALE PRIVACY TERMS -->
      <wg-modal
        :width="windowWidth > 900 ? '900px' : '90%'"
        v-if="showPrivacyModal"
        @closeModal="showPrivacyModal = false"
      >
        <div slot="header">Privacy Policy</div>
        <div slot="body" class="wg-row">
          <div
            class="wg-row"
            style="text-align: center"
            v-html="privacyPolicy"
          ></div>
        </div>
      </wg-modal>
      <!-- MODALE PER INSERIMENTO DATI DI FATTURAZIONE -->
      <wg-modal v-if="showInvoiceModal" @closeModal="closeInvoiceModal">
        <div slot="header">
          {{ $anm22.strLang(lang, "Invoice data", "Dati fatturazione") }}
        </div>
        <world-invoice-form slot="body" @create-invoice="setInvoiceData">
        </world-invoice-form>
      </wg-modal>
      <!-- VARIATIONS MODAL -->
      <var-modal
        v-if="varModalElement"
        :show="showVarModal"
        :element="varModalElement"
        @set-variations="setVariations"
      ></var-modal>
      <!-- INFO MODAL -->
      <wg-modal
        v-if="showInfoModal"
        @closeModal="showInfoModal = false"
        :width="windowWidth >= 992 ? '600px' : '90%'"
      >
        <div slot="body" class="wg-row">
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            class="wg-row"
            style="justify-content:center;align-items:center;"
          >
            <div
              style="
                min-width: 35px;
                width: 35px;
                height: 35px;
                margin-right: 10px;
              "
            >
              <world-object-icon :type="'work'" :obj="work" :isImg="true">
              </world-object-icon>
            </div>
            <div style="font-size: 24px">
              {{ license.name || work.name }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="wg-row"
              style="align-items:center;flex-wrap:nowrap;padding-bottom:5px;border-bottom:1px solid #ccc;"
            >
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('time')"
              />
              <div
                class="com-anm22-app-text-xl"
                style="font-weight:bold;margin-left:5px;"
              >
                {{ $anm22.strLang(lang, "Hours", "Orari") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-direction:column;padding:0 5px;">
              <div
                v-for="(day, i) in license.openingHours"
                :key="'oh-' + i"
                class="wg-row"
                :style="{
                  fontWeight: now.isoWeekday() - 1 == i ? 'bold' : '',
                  marginBottom: '5px',
                }"
              >
                <div class="wg-col wg-xs-12 wg-sm-4 com-anm22-app-text-l">
                  {{
                    $anm22.capitalizeFirst(
                      $moment.tz(i + 1, "E", timezone).format("dddd")
                    )
                  }}
                </div>
                <div class="wg-col wg-xs-12 wg-sm-8 com-anm22-app-text-l">
                  <div class="wg-row">
                    <div
                      v-for="(oh, j) in day"
                      :key="'oh-' + i + '-' + j"
                      class="display-flex"
                      style="margin-right:5px;"
                    >
                      {{
                        $moment
                          .tz(oh["from"], "HH:mm", timezone)
                          .format("HH:mm") +
                          " - " +
                          $moment
                            .tz(oh["to"], "HH:mm", timezone)
                            .format("HH:mm")
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="address">
            <div class="vertical-height-div" style="height:15px;"></div>
            <div
              class="wg-row modal-info-address-label"
              style="align-items:center;flex-wrap:nowrap;padding-bottom:5px;border-bottom:1px solid #ccc;"
            >
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('placeBlack')"
              />
              <div
                class="com-anm22-app-text-xl"
                style="font-weight:bold;margin-left:5px;"
              >
                {{ $anm22.strLang(lang, "Address", "Indirizzo") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row modal-info-address-data">
              <div class="com-anm22-app-text-xl" style="margin-left: 5px">
                {{ address }}
              </div>
            </div>
            <!-- <template v-if="place.latitude && place.longitude">
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row" style="height:200px;">
                <GmapMap
                  v-if="!isOffline"
                  ref="mapRef"
                  :center="{ lat: place.latitude, lng: place.longitude }"
                  :zoom="5"
                  map-type-id="roadmap"
                  style="width:100%;height:100%;"
                >
                  <GmapMarker
                    :position="{ lat: place.latitude, lng: place.longitude }"
                    :icon="{
                      size: new google.maps.Size(32, 32),
                      scaledSize: new google.maps.Size(32, 32),
                      url: $anm22.icons.getFoodIcon('markerFood')
                    }"
                    :zIndex="1"
                  />
                </GmapMap>
                <img
                    v-else
                    class="com-anm22-app-img-l"
                    style="margin:auto;"
                    :src="$anm22.icons.getWorldIcon('offline')"
                >
              </div>
            </template> -->
            <div class="vertical-height-div" style="height:20px;"></div>
          </template>
          <div class="vertical-height-div" style="height:15px;"></div>
          <div
            v-if="work.phoneAreaCode && work.phoneNumber"
            class="wg-row modal-info-phone-box"
          >
            <div
              class="wg-row modal-info-phone-label"
              style="align-items:center;flex-wrap:nowrap;padding-bottom:5px;border-bottom:1px solid #ccc;"
            >
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('phone')"
              />
              <div
                class="com-anm22-app-text-xl"
                style="font-weight:bold;margin-left:5px;"
              >
                {{ $anm22.strLang(lang, "Phone", "Telefono") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <a
              class="modal-info-phone-link"
              style="margin-left:5px;"
              :href="'tel:' + work.phoneAreaCode + work.phoneNumber"
            >
              <div class="com-anm22-app-text-l">
                {{ work.phoneAreaCode + " " + work.phoneNumber }}
              </div>
            </a>
          </div>
          <div class="vertical-height-div" style="height:15px;"></div>
        </div>
      </wg-modal>
      <!-- MAIN PAGE -->
      <div
        class="wg-row"
        style="
          justify-content: space-between;
          align-items: center;
          position: relative;
          overflow-x: hidden;
        "
      >
        <!-- INFO + MENU -->
        <div
          id="main-scrolling-div"
          class="wg-col wg-xs-12 wg-md-9 com-anm22-app-scrolling-panel menu"
          :style="{ height: windowHeight - 60 + 'px' }"
        >
          <div class="wg-row">
            <!-- INFO = COVER + INFO_CARD (sticky) -->
            <div class="wg-row cover" :style="coverStyle"></div>
            <div
              class="wg-row info card"
              :style="{ height: infoCardHeight + 'px' }"
            >
              <div class="wg-row" style="flex-direction: column">
                <div class="wg-row" style="align-items: center">
                  <div
                    :class="'license-logo-container ' + license.licenseHash"
                    style="min-width:30px;width:30px;height:30px;margin-right:5px;"
                  >
                    <world-object-icon :type="'work'" :obj="work" :isImg="true">
                    </world-object-icon>
                  </div>
                  <div class="com-anm22-app-text-xl">
                    {{ license.name || work.name }}
                  </div>
                  <img
                    class="com-anm22-app-img-fixed-height-m"
                    :src="$anm22.icons.getWorldIcon('info')"
                    style="margin-left:5px;cursor:pointer;opacity:0.4;"
                    @click="showInfoModal = true"
                  />
                </div>
                <div v-if="error" class="wg-row error">
                  <div
                    v-if="error === 1"
                    class="com-anm22-app-text-m"
                    style="text-align: center"
                  >
                    {{
                      $anm22.strLang(
                        lang,
                        "! We are sorry but the selected store isn't taking order at the moment",
                        "! Ci dispiace ma il locale non accetta ordini al momento"
                      )
                    }}
                  </div>
                  <div
                    v-else-if="error === 2"
                    class="com-anm22-app-text-m"
                    style="text-align: center"
                  >
                    {{
                      $anm22.strLang(
                        lang,
                        "! This restaurant only accepts Spiagge.it as valid payment method. Unfortunately, no Spiagge.it active registration has been found for this user.",
                        "! Questo locale accetta solo Spiagge.it come metodo di pagamento valido. Sfortunatamente, non è stata trovata alcuna registrazione valida su Spiagge.it per questo utente."
                      )
                    }}
                  </div>
                </div>
                <!-- Opening hours -->
                <div class="wg-row hours">
                  <img
                    class="com-anm22-app-img-fixed-height-s"
                    :src="$anm22.icons.getWorldIcon('time')"
                  />
                  <div class="com-anm22-app-text-l" style="margin:0 5px;">
                    {{ todayOhString }}
                  </div>
                  <div
                    v-if="license.seasonalClosure"
                    class="com-anm22-app-text-l"
                    style="color:#EF5350;"
                  >
                    {{
                      $anm22.strLang(
                        lang,
                        "Seasonal closure",
                        "Chiusura stagionale"
                      )
                    }}
                  </div>
                  <div
                    v-else-if="open"
                    class="com-anm22-app-text-l"
                    style="color:#64dd17;"
                  >
                    {{ $anm22.strLang(lang, "Open now", "Aperto ora") }}
                  </div>
                  <div
                    v-else
                    class="com-anm22-app-text-l"
                    style="color:#EF5350;"
                  >
                    {{ $anm22.strLang(lang, "Closed now", "Chiuso ora") }}
                  </div>
                </div>
              </div>
              <div class="wg-md-none cart-counter-button">
                <div
                  class="wg-row"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    height: 100%;
                    justify-content: center;
                  "
                  @click.stop="openCart"
                >
                  <div class="display-flex">
                    <div v-show="elements.length > 0" class="elements-counter">
                      {{ elements.length }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- MENU = CATEGORIES (sticky) + PRODUCTS -->
            <products
              :topOffset="infoCardHeight"
              :elements="elements"
              @add-element="addElement"
            ></products>
          </div>
        </div>
        <!-- CART -->
        <div
          :class="[
            'wg-col',
            'wg-xs-12',
            'wg-md-3',
            'com-anm22-food-po-control-panel',
            'com-anm22-app-scrolling-panel',
            'cart',
            cartOpen === null ? '' : cartOpen ? 'slide-in' : 'slide-out',
          ]"
          :style="{ height: windowHeight - 60 + 'px' }"
        >
          <!-- ARTICOLI E TOTALI -->
          <div class="articles-div">
            <div
              class="wg-row"
              style="
                align-items: center;
                flex-wrap: nowrap;
                justify-content: center;
                position: relative;
              "
            >
              <div class="com-anm22-app-text-xxl">
                {{ $anm22.strLang(lang, "Your cart", "Il tuo carrello") }}
              </div>
              <!-- <div
                class="wg-md-none com-anm22-app-text-l"
                style="position:absolute;right:0;cursor:pointer;border:1px solid #ccc;padding:5px;border-radius:4px;"
                @click="closeCart"
              >{{ $anm22.strLang(lang, 'Close', 'Chiudi') }}</div> -->
            </div>
            <div class="vertical-height-div" style="height: 10px"></div>
            <div
              class="wg-row"
              style="justify-content:center;text-align:center;"
            >
              <div v-if="toPay.length === 0" class="com-anm22-app-text-l">
                {{
                  $anm22.strLang(
                    lang,
                    "Start adding elements to the cart!",
                    "Inizia ad aggiungere elementi al carrello!"
                  )
                }}
              </div>
              <item-row
                v-for="(row, index) in toPayRows"
                :key="'row-' + index"
                :row="row"
                @delete-article="deleteArticle"
              ></item-row>
            </div>
            <div class="vertical-height-div" style="height: 10px"></div>
            <div class="com-anm22-app-horizontal-line-light"></div>
            <div class="vertical-height-div" style="height: 10px"></div>
            <div class="wg-row">
              <div
                class="wg-row"
                :style="{
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                }"
              >
                <div class="wg-col wg-xs-8">
                  <div class="com-anm22-app-text-l">
                    {{
                      $anm22.strLang(
                        lang,
                        "Delivery cost:",
                        "Costo di consegna:"
                      )
                    }}
                  </div>
                </div>
                <div
                  class="wg-col wg-xs-4 display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: flex-end;
                  "
                >
                  <div class="com-anm22-app-text-l">
                    {{ "&euro; " + order.deliveryPrice.toFixed(2) }}
                  </div>
                </div>
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <template v-if="surcharge > 0">
                <div
                  class="wg-row"
                  :style="{
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                  }"
                >
                  <div class="wg-col wg-xs-8">
                    <div class="com-anm22-app-text-l">
                      {{
                        $anm22.strLang(lang, "Service cost:", "Costo servizio:")
                      }}
                    </div>
                  </div>
                  <div
                    class="wg-col wg-xs-4 display-flex"
                    style="
                      flex-wrap: nowrap;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <div class="com-anm22-app-text-l">
                      {{ "&euro; " + Number(surcharge).toFixed(2) }}
                    </div>
                  </div>
                </div>
                <div class="vertical-height-div" style="height: 5px"></div>
              </template>
              <div
                class="wg-row"
                :style="{
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                }"
              >
                <div class="wg-col wg-xs-8">
                  <div class="com-anm22-app-text-l">
                    {{ $anm22.strLang(lang, "Total:", "Totale:") }}
                  </div>
                </div>
                <div
                  class="wg-col wg-xs-8 display-flex"
                  style="
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: flex-end;
                  "
                >
                  <div class="com-anm22-app-text-l">
                    {{ "&euro; " + totalToPay.toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="com-anm22-app-horizontal-line-light"></div>
          <div
            class="wg-row"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="com-anm22-app-text-s wg-p-xs-20">
              {{
                $anm22.strLang(
                  lang,
                  "*Click on product to add changes.",
                  "*Clicca sui prodotti nel carrello per aggiungere variazioni."
                )
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div
            class="wg-row"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, "Notes", "Note") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row" style="padding: 0 10px">
            <textarea
              style="
                max-width: 100%;
                width: 100%;
                height: 100px;
                border: 1px solid #ddd;
              "
              v-model="order.notes"
              :placeholder="
                $anm22.strLang(
                  lang,
                  'Write here your food allergies. Don\'t use this field for product changes.',
                  'Indica eventuali allergie o intolleranze. Non usare questo campo per variazioni ai prodotti.'
                )
              "
            ></textarea>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <!-- Opzioni di consegna -->
          <div class="wg-row" style="justify-content: center">
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, "Delivery", "Consegna") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div v-if="!deliveryCondition" class="wg-row" style="padding: 0 10px">
            <div
              class="com-anm22-app-text-l"
              style="color: #f44336; text-align: center"
            >
              {{
                $anm22.strLang(
                  lang,
                  "An order of minimum " +
                    license.minToDelivery +
                    "€ is required for this delivery option",
                  "È richiesto un ordine minimo di " +
                    license.minToDelivery +
                    "€ per scegliere questa opzione di consegna"
                )
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row no-select">
            <div
              class="wg-row"
              style="
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-around;
              "
            >
              <div
                v-for="(dt, index) in deliveryTypes.map((dt) =>
                  $anm22.tableClasses.worldDeliveryType().getById(dt)
                )"
                :key="'dt+' + index"
                :class="[
                  'display-flex',
                  'action-btn',
                  order.deliveryType === dt.typeClass ? 'selected' : '',
                  deliveryBlocked && !deliveryBlocked.includes(dt.typeClass)
                    ? 'disabled'
                    : '',
                ]"
                :style="{ width: 85 / deliveryTypes.length + '%' }"
                @click="setDeliveryType(dt)"
              >
                <img
                  :src="$anm22.icons.getWorldIcon(dt.typeClassLiteral)"
                  class="com-anm22-app-img-fixed-height-l"
                  :title="dt[lang]"
                />
              </div>
            </div>
            <div
              class="wg-row"
              style="margin-top: 10px; justify-content: center"
            >
              <div class="com-anm22-app-text-xl">{{ deliveryLabel }}</div>
            </div>
            <div
              v-if="order.deliveryType !== 5"
              class="wg-row"
              style="
                flex-wrap: nowrap;
                align-items: center;
                margin-top: 10px;
                justify-content: space-around;
              "
            >
              <div class="com-anm22-app-text-l" style="width: 40%">
                {{ $anm22.strLang(lang, "Time", "Orario") }}
              </div>
              <select
                class="com-anm22-app-select"
                style="width: 40%"
                :value="order.deliveryTime"
                @change="checkAvailability"
              >
                <option value="" selected disabled>
                  {{ $anm22.strLang(lang, "Select one", "Seleziona") }}
                </option>
                <option
                  v-for="(ds, i) in deliverySlots"
                  :disabled="!ds.free"
                  :key="'ds-' + i"
                  :value="ds.slot.unix()"
                >
                  {{ ds.slot.format("l LT") }}
                </option>
              </select>
            </div>
            <div
              v-if="order.deliveryType == 1 || order.deliveryType == 2"
              class="wg-row"
              style="margin-top: 10px; justify-content: space-around"
            >
              <select
                :disabled="deliveryBlocked"
                class="com-anm22-app-select"
                style="width: 40%"
                v-model="order.beach"
              >
                <option
                  v-for="(beach, index) in beaches"
                  :key="'beach-' + index"
                  :value="beach.idWorldWork"
                >
                  {{ beach.name }}
                </option>
              </select>
              <input
                :disabled="deliveryBlocked"
                type="text"
                style="
                  margin-right: 5px;
                  margin-left: 10px;
                  user-select: auto;
                  width: 40%;
                "
                :placeholder="$anm22.strLang(lang, 'Umbrella', 'Ombrellone')"
                v-model="order.beachUmbrella"
              />
            </div>
            <div
              v-if="order.deliveryType == 5"
              class="wg-row"
              style="margin-top: 10px; justify-content: space-around"
            >
              <select
                :disabled="deliveryBlocked"
                class="com-anm22-app-select"
                style="width: 100px"
                v-model="order.tableRef"
              >
                <option
                  v-for="(table, index) in tables"
                  :key="'table-' + index"
                  :value="table.id"
                >
                  {{ table.name }}
                </option>
              </select>
            </div>
            <div
              v-if="order.deliveryType == 7"
              class="wg-row"
              style="
                margin-top: 10px;
                justify-content: space-around;
                padding-left: 5px;
              "
            >
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                  v-model="order.deliveryData.name"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                  v-model="order.deliveryData.street"
                />
                <input
                  style="width:40px;margin-left:5px;"
                  type="text"
                  placeholder="N."
                  v-model="order.deliveryData.number"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="wg-row" style="flex-wrap:nowrap;">
                <input
                  class="full"
                  type="text"
                  :placeholder="
                    $anm22.strLang(
                      lang,
                      'Building/unit',
                      'Edificio/appartamento'
                    )
                  "
                  v-model="order.deliveryData.line2"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'City', 'Città')"
                  v-model="order.deliveryData.city"
                />
                <input
                  style="width:80px;margin-left:5px;"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
                  v-model="order.deliveryData.zip"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
                  v-model="order.deliveryData.state"
                />
                <select
                  class="com-anm22-app-select"
                  style="margin-left:5px;"
                  v-model="order.deliveryData.country"
                >
                  <option value="it" selected>
                    {{ $anm22.strLang(lang, "Italy", "Italia") }}
                  </option>
                  <option value="rsm">
                    {{
                      $anm22.strLang(
                        lang,
                        "Republic of San Marino",
                        "Republica di San Marino"
                      )
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="order.deliveryType == 9"
              class="wg-row"
              style="margin-top:10px;justify-content:space-around;"
            >
              <select
                :disabled="deliveryBlocked"
                class="com-anm22-app-select"
                style="width:80%;"
                v-model="order.pickUpPoint"
              >
                <option value="" selected disabled>
                  {{
                    $anm22.strLang(
                      lang,
                      "Select pick-up point",
                      "Seleziona punto di ritiro"
                    )
                  }}
                </option>
                <option
                  v-for="(point, i) in license.deliveryPickUpPoints"
                  :key="'pup-' + i"
                  :value="point"
                >
                  {{ point[lang] }}
                </option>
              </select>
            </div>
            <div
              v-if="order.deliveryType == 10"
              class="wg-row"
              :style="{
                marginTop: '10px',
                justifyContent: 'space-around',
                paddingLeft: '5px',
              }"
            >
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                  v-model="order.deliveryData.name"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                  v-model="order.deliveryData.street"
                />
                <input
                  style="width:40px;margin-left:5px;"
                  type="text"
                  placeholder="N."
                  v-model="order.deliveryData.number"
                />
              </div>
            </div>
            <div
              v-if="order.deliveryType !== 5"
              class="wg-row"
              :style="{
                marginTop: '10px',
                justifyContent: 'space-around',
                paddingLeft: '5px',
              }"
            >
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="tel"
                  :placeholder="$anm22.strLang(lang, 'Phone', 'Telefono') + '*'"
                  v-model="order.deliveryData.phone"
                />
              </div>
              <div class="vertical-height-div" style="height: 5px"></div>
              <div class="wg-row" style="flex-wrap: nowrap">
                <input
                  class="full"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Notes', 'Note')"
                  v-model="order.deliveryData.notes"
                />
              </div>
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <!-- Opzioni di pagamento -->
          <div class="wg-row" style="justify-content:center;">
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, "Payment", "Pagamento") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="wg-row no-select">
            <div
              class="wg-row"
              style="flex-wrap:nowrap;align-items:center;justify-content:space-around;"
            >
              <div
                v-for="(pm, index) in paymentMethods.map((pm) =>
                  $anm22.tableClasses.worldPaymentModeType().getById(pm)
                )"
                :key="'pm+' + index"
                :class="[
                  'display-flex',
                  'action-btn',
                  order.paymentMethod === pm.typeClass ? 'selected' : '',
                ]"
                :style="{ width: 95 / paymentMethods.length + '%' }"
                @click="setPaymentMethod(pm)"
              >
                <img
                  :src="
                    $anm22.icons.getWorldIcon(
                      'payment' + $anm22.capitalizeFirst(pm.typeClassLiteral)
                    )
                  "
                  class="com-anm22-app-img-fixed-height-l"
                  :title="pm[lang]"
                />
              </div>
            </div>
            <div class="wg-row" style="margin-top:10px;justify-content:center;">
              <div class="com-anm22-app-text-xl">{{ paymentLabel }}</div>
            </div>
          </div>
          <template
            v-if="
              !user && paymentMethods.includes(7) && order.paymentMethod === 7
            "
          >
            <div class="vertical-height-div" style="height:10px;"></div>
            <div
              class="wg-row"
              style="justify-content:center;text-align:center;"
            >
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "To confirm Spiagge.it payment a valid registration will be searched for after logging in.",
                    "Per confermare il pagamento tramite Spiagge.it verrà ricercata una prenotazione valida dopo aver effettuato l'accesso"
                  )
                }}
              </div>
            </div>
          </template>
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- Ricevuta -->
          <div class="wg-row" style="justify-content:center;">
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, "Receipt", "Ricevuta") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="wg-row no-select">
            <div
              class="wg-row"
              style="flex-wrap:nowrap;align-items:center;justify-content:space-around;"
            >
              <div
                v-for="(rt, index) in receiptTypes.map((rt) =>
                  $anm22.tableClasses.worldReceiptType().getById(rt)
                )"
                :key="'rt+' + index"
                :class="[
                  'display-flex',
                  'action-btn',
                  receiptType === rt.typeClass ? 'selected' : '',
                ]"
                :style="{ width: 95 / receiptTypes.length + '%' }"
                @click="setReceiptType(rt)"
              >
                <img
                  :src="$anm22.icons.getWorldIcon(rt.typeClassLiteral)"
                  class="com-anm22-app-img-fixed-height-l"
                  :title="rt[lang]"
                />
              </div>
            </div>
            <div class="wg-row" style="margin-top:10px;justify-content:center;">
              <div class="com-anm22-app-text-xl">{{ receiptLabel }}</div>
            </div>
          </div>
          <!-- Pulsante ordinazione -->
          <div
            class="wg-row po-order-button"
            :style="{
              position: 'static',
              display: 'block',
              margin: '20px auto 0 auto',
              textAlign: 'center',
              cursor: deliveryCondition && !error ? 'pointer' : 'default',
              opacity: deliveryCondition && !error ? '1' : '0.3',
              pointerEvents: deliveryCondition && !error ? 'auto' : 'none',
            }"
            @click="updating ? '' : save()"
          >
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, "Confirm", "Ordina") }}
            </div>
          </div>
          <div
            class="wg-row com-anm22-app-text-s"
            style="
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              padding: 10px;
              text-align: center;
            "
          >
            <div class="com-anm22-app-text-s">
              {{
                $anm22.strLang(
                  lang,
                  "By clicking 'Confirm' you have read and agree to the",
                  "Cliccando su 'Ordina' dichiari di aver letto e accetti"
                )
              }}
              <a href="javascript:;" style="color: #999" @click="showTerms">{{
                $anm22.strLang(
                  lang,
                  " Terms and Condition",
                  " Termini e Condizioni"
                )
              }}</a>
              {{ $anm22.strLang(lang, " and the ", " e la ") }}
              <a href="javascript:;" style="color: #999" @click="showPrivacy"
                >Privacy Policy</a
              >
              {{
                $anm22.strLang(lang, " of the restaurant.", " del ristorante.")
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 20px"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import VarModal from "../../components/customer/VarModal.vue";
import MobileTitleBar from "../../components/customer/MobileTitleBar.vue";
import Products from "../../components/customer/Products.vue";
import ItemRow from "../../components/customer/ItemRow.vue";
import WorldInvoiceForm from "../../../../../world/spa/components/WorldInvoiceForm.vue";
import AuthModal from "../../components/customer/AuthModal.vue";
// Google maps
import { gmapApi } from "gmap-vue";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    MobileTitleBar,
    Products,
    ItemRow,
    VarModal,
    WorldInvoiceForm,
    AuthModal,
  },
  data() {
    return {
      loading: true,
      updating: false,
      /* Apertura carrello (mobile) */
      cartOpen: null,
      defaultBackHref: this.$store.getters["headbar/getBackHref"],
      mainScroll: 0,
      /* Supporto */
      sequence: 1,
      maxSeq: 1,
      /* Variabili per costi di consegna */
      deliveryCondition: true,
      deliveryBlocked: null,
      /* Ordine ed elementi - vengono gestiti in copia dallo store o ex novo */
      order: null,
      elements: [],
      /* Variazioni */
      showVarModal: false,
      varModalElement: null,
      /*  */
      showInvoiceModal: false,
      showNotesModal: false,
      showTermsModal: false,
      showPrivacyModal: false,
      showInfoModal: false,
      showLoginModal: false,
      // Delivery time check
      showDeliveryTimeModal: false,
      checkingSlot: false,
      slotOccupiedCat: [],
      privacyPolicy: "",
      ybRegs: {
        regs: [],
        active: false,
      },
      payCards: [],
      receiptType: 1,
      pageStyle: "standard",
      pageCustomCSS: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      licenseSelected: (state) => state.licenseSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
      isOffline: (state) => state.offline.isOffline,
      appColor: (state) => state.config.appColor,
    }),
    lang() {
      if (this.user) {
        return this.$store.state.lang;
      } else {
        return (navigator.language || navigator.userLanguage).substring(0, 2);
      }
    },
    google: gmapApi,
    infoCardHeight() {
      if (this.error) {
        return 100;
      } else {
        return 70;
      }
    },
    productsHeight() {
      return this.windowHeight - 80 - (this.windowWidth < 992 ? 49 : 0);
    },
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.licenseSelected
      );
    },
    work() {
      return this.$store.getters["works/get"](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    place() {
      const places = this.$store.getters["workPlaceAssocs/getByWork"](
        this.work.idWorldWork
      )
        .filter((wp) => wp.isMain)
        .map((wpa) => this.$store.getters["places/get"](wpa.place));
      if (places.length > 0) {
        return places[0];
      } else {
        return null;
      }
    },
    address() {
      if (this.place) {
        return this.$anm22.getAddressFromPlace(this, this.place);
      } else {
        return "";
      }
    },
    // Styles
    coverStyle() {
      return {
        backgroundImage: "url(" + this.license.coverImg + ")",
      };
    },
    now() {
      return this.$moment().tz(this.timezone);
    },
    open() {
      if (this.license.seasonalClosure) {
        return false;
      }
      const day = this.license.openingHours[this.now.isoWeekday() - 1];
      for (let i = 0; i < day.length; i++) {
        const ohs = day[i];
        const from = this.$moment.tz(ohs["from"], "HH:mm", this.timezone);
        const to = this.$moment.tz(ohs["to"], "HH:mm", this.timezone);
        if (to.isBefore(from, "hour minute")) {
          to.add(1, "days");
        }
        if (this.now.isBetween(from, to, "hour minute", "[]")) {
          return true;
        }
      }
      return false;
    },
    todayOhString() {
      let string = "";
      const today = this.license.openingHours[this.now.isoWeekday() - 1];
      for (let i = 0; i < today.length; i++) {
        const oh = today[i];
        string +=
          this.$moment.tz(oh["from"], "HH:mm", this.timezone).format("HH:mm") +
          " - " +
          this.$moment.tz(oh["to"], "HH:mm", this.timezone).format("HH:mm") +
          " ";
      }
      return string;
    },
    error() {
      // Restaurant accepts orders
      if (this.license.interrupted) {
        return 1;
      }
      // YB payment
      if (this.paymentMethods.length === 0) {
        return 2;
      }
      return null;
    },
    paymentMethods() {
      return this.license.paymentMethods
        .filter((p) => {
          if (!p.customer) {
            return false;
          }
          if (p.id === 7) {
            if (this.user && !this.ybRegs.active) {
              return false;
            }
          }
          if (p.id === 9) {
            if (this.user && this.payCards.length == 0) {
              return false;
            }
          }
          return true;
        })
        .map((p) => p.id);
    },
    deliveryTypes() {
      return this.license.deliveryTypes
        .filter((d) => {
          if (!d.customer) {
            return false;
          }
          if ((d.id === 1 || d.id === 2) && this.beaches.length === 0) {
            return false;
          }
          if (d.id === 5) {
            // ristorante deve essere aperto
            if (!this.open) {
              return false;
            }
            // deve esserci un tavolo disponibile
            if (
              this.tables.length === 0 ||
              this.tables.reduce((res, t) => res && t.isOccupied, true)
            ) {
              return false;
            }
          }
          return true;
        })
        .map((d) => d.id);
    },
    deliveryPrices() {
      return this.license.deliveryPrices;
    },
    receiptTypes() {
      return this.license.customerReceiptTypes
        .filter((rt) => rt.customer)
        .map((r) => r.id);
    },
    deliveryLabel() {
      return this.$anm22.tableClasses
        .worldDeliveryType()
        .getById(
          this.deliveryTypes.find((dt) => dt === this.order.deliveryType)
        )[this.lang];
    },
    paymentLabel() {
      return this.$anm22.tableClasses
        .worldPaymentModeType()
        .getById(
          this.paymentMethods.find((pm) => pm === this.order.paymentMethod)
        )[this.lang];
    },
    receiptLabel() {
      return this.$anm22.tableClasses
        .worldReceiptType()
        .getById(this.receiptTypes.find((rt) => rt === this.receiptType))[
        this.lang
      ];
    },
    tables() {
      return this.$store.getters["foodTables/getByLicense"](
        this.license.id
      ).filter((t) => !t.deleted);
    },
    products() {
      return this.$store.getters["foodProducts/getByLicense"](
        this.license.id
      ).filter((p) => !p.deleted && p.visibleByCustomer);
    },
    beaches() {
      return this.$store.getters["ybLicenses/getByLicense"](
        this.license.id
      ).map((ybl) => this.$store.getters["works/get"](ybl.beach));
    },
    /* ARRAY DI GESTIONE DEGLI ELEMENTI DELL'ORDINE */
    toPay: function() {
      return this.elements
        .filter((e) => !e.payed)
        .sort((a, b) => a.product - b.product);
    },
    toPayRows: function() {
      let result = [];
      this.toPay.forEach((e) => {
        if (e.weight === "") {
          if (e.variations.length === 0) {
            /* cerco se una riga con questo prodotto è già presente nell'array */
            const found = result.findIndex(
              (row) =>
                row.elem.product === e.product &&
                row.elem.variations.length === 0
            );
            /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
            if (-1 !== found) {
              result[found].elem = e;
              result[found].quantity++;
              result[found].price += e.price;
            } else {
              result.push({
                elem: e,
                weightEdit: null,
                priceEdit: false,
                deletable: true,
                onclick: this.openVarModal,
                quantity: 1,
                weight: null,
                price: e.price,
              });
            }
          } else {
            result.push({
              elem: e,
              weightEdit: null,
              priceEdit: false,
              deletable: true,
              onclick: this.openVarModal,
              quantity: 1,
              weight: null,
              price: e.price,
            });
          }
        } else {
          result.push({
            elem: e,
            weightEdit: false,
            priceEdit: false,
            deletable: true,
            onclick: this.openVarModal,
            quantity: 1,
            weight: e.weight,
            price: e.price,
          });
        }
      });
      return result;
    },
    /* TOTALI */
    totalArticles() {
      let result = 0;
      //Articoli + variazioni
      this.toPay.forEach((e) => {
        result += e.price;
        e.variations.forEach((v) => {
          result += v.price;
        });
      });
      // Coperti non contemplati nell'ordinazione da customer
      //Costo di consegna
      if (this.order.deliveryPrice) {
        result += this.order.deliveryPrice;
      }
      return this.$anm22.round(result, 2);
    },
    surcharge() {
      const fixedSurcharge = this.license.paymentSurcharges[
        this.order.paymentMethod
      ]["fixed"];
      const percentSurcharge = this.license.paymentSurcharges[
        this.order.paymentMethod
      ]["percent"];
      const surcharge =
        fixedSurcharge +
        this.$anm22.round((this.totalArticles / 100) * percentSurcharge, 2);
      if (surcharge) {
        return this.$anm22.round(surcharge, 2);
      } else {
        return 0;
      }
    },
    // Nell'ordinazione da customer totalOrder è uguale a totalToPay
    totalToPay() {
      return this.$anm22.round(this.totalArticles + this.surcharge, 2);
    },
    deliverySlots() {
      return this.$anm22.food_getDeliverySlots({
        vue: this,
        license: this.license,
        timezone: this.timezone,
        isCustomer: true,
      });
    },
  },
  methods: {
    mainScrolled(e) {
      this.mainScroll = e.target.scrollTop;
    },
    showTerms() {
      if (this.license.termsType === 1) {
        this.showTermsModal = true;
      } else {
        window.open(this.license.termsUrl, "_blank");
      }
    },
    async showPrivacy() {
      if (!this.privacyPolicy) {
        const response = await this.$http.get("auth/policy");
        this.privacyPolicy = response.data.terms;
      }
      this.showPrivacyModal = true;
    },
    openCart() {
      this.cartOpen = true;
    },
    closeCart() {
      this.cartOpen = false;
    },
    // checkProducts() {
    //   clearTimeout(this.productTimer);
    //   this.productTimer = setTimeout(() => {
    //     this.$http
    //       .post("fast-cash/check-products", {
    //         elements: this.toPay
    //       })
    //       .then(response => {
    //         response.forEach(item => {
    //           // Aggiorno il prodotto
    //           const product = this.products.find(
    //             p => p.idProduct === item.idProd
    //           );
    //           if (product) {
    //             product.quantity = item.qnt;
    //             this.$store.dispatch("foodProducts/update", {
    //               vlf: this.$vlf("foodProducts"),
    //               objs: [product]
    //             });
    //             if (item.over) {
    //               this.$anm22.eventBus.$emit("world-headbar-show-message", {
    //                 text: this.$anm22.strLang(
    //                   this.lang,
    //                   "Only " +
    //                     product.quantity +
    //                     " units of " +
    //                     product.name +
    //                     " in stock",
    //                   "Solo " +
    //                     product.quantity +
    //                     " unità di " +
    //                     product.name +
    //                     " in magazzino"
    //                 ),
    //                 type: "alarm"
    //               });
    //             }
    //           }
    //         });
    //       })
    //       .catch(error => {});
    //   }, 500);
    // },
    async checkAvailability(ev) {
      this.checkingSlot = true;
      // get Timestamp
      const ts = Number.parseInt(ev.target.value);
      this.showDeliveryTimeModal = true;
      try {
        const response = await this.$http.post("place-order/check-slot", {
          ts: ts,
          elements: this.toPay,
          licenseCode: this.licenseSelected,
        });
        if (response.data.error !== "") {
          throw new Error("response_error");
        } else {
          if (!response.data.free) {
            // Disabilito lo slot di consegna
            this.deliverySlots.find((ds) => ds.slot.unix() === ts).free = false;
            // Mostro un messaggio
            this.slotOccupiedCat = response.data.categories;
          } else {
            this.order.deliveryTime = ts;
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "Delivery time accepted",
                "Orario di consegna disponibile"
              ),
              type: "confirm",
            });
            this.showDeliveryTimeModal = false;
          }
        }
      } catch (e) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "There was an error, please try again",
            "Si è verificato un problema, riprovare"
          ),
          type: "alarm",
        });
        this.showDeliveryTimeModal = false;
      } finally {
        this.checkingSlot = false;
      }
    },
    emptyCart() {
      this.elements = this.elements.filter((e) => e.payed);
    },
    addElement(product) {
      const localId = this.$anm22.genLocalId();
      const weight = product.pricingType === 2 ? product.defaultQuantity : "";
      const price =
        product.pricingType === 2 ? product.price * weight : product.price;
      this.elements.push({
        id: localId,
        dkKey: localId,
        product: product.id,
        productName: product.langName,
        productUnitPrice: product.price,
        productVat: product.vat,
        productUom: product.uom,
        variations: [],
        weight,
        price: price,
        payed: false,
        toInsert: true,
        sequence: this.sequence,
        notes: "",
      });
      // if (product.stockType !== 1) {
      //   this.checkProducts();
      // }
    },
    deleteArticle(id) {
      const index = this.elements.findIndex((e) => e.id === id);
      if (-1 !== index) {
        const element = this.elements.splice(index, 1)[0];
        // this.checkSequences();
        const product = this.products.find((p) => p.id === element.product);
        // if (product && product.stockType !== 1) {
        //   this.checkProducts();
        // }
      }
    },
    openVarModal(elem) {
      if (elem) {
        this.varModalElement = elem;
        this.showVarModal = true;
      }
    },
    setVariations(vars) {
      this.showVarModal = false;
      const element = this.elements.find(
        (e) => e.id === this.varModalElement.id
      );
      if (-1 !== element) {
        element.variations = vars;
      }
      this.varModalElement = null;
    },
    setPaymentMethod(pm) {
      this.order.paymentMethod = pm.typeClass;
    },
    setDeliveryType(dt) {
      this.order.deliveryType = dt.typeClass;
      if (dt.typeClass == 1 || dt.typeClass == 2) {
        // Controllo se c'è un'unica spiaggia associata
        if (this.beaches.length === 1) {
          this.order.beach = this.beaches[0].idWorldWork;
        }
      } else {
        this.order.beach = "";
        this.order.beachUmbrella = "";
      }
      if (dt.typeClass == 5) {
        this.order.deliveryTime = "";
        if (this.tables.length === 1) {
          this.order.tableRef = this.tables[0].id;
        }
      } else {
        this.order.tableRef = "";
      }
      if (dt.typeClass == 9) {
      } else {
        this.order.pickUpPoint = "";
      }
      if (dt.typeClass != 7 || dt.typeClass != 10) {
        this.order.deliveryData = {
          country: "it",
        };
      }
      this.$nextTick(() => this.checkDeliveryCondition());
    },
    checkDeliveryCondition() {
      // Delivery price management
      this.order.deliveryPrice = 0;
      this.deliveryCondition = true;
      switch (this.license.deliveryOption) {
        case 1:
          this.order.deliveryPrice = this.deliveryPrices[
            this.order.deliveryType
          ];
          break;
        case 2:
          if (this.totalToPay < this.license.minToDelivery) {
            this.order.deliveryPrice = this.deliveryPrices[
              this.order.deliveryType
            ];
          }
          break;
        case 3:
          if (this.totalToPay < this.license.minToDelivery) {
            this.deliveryCondition = false;
          }
          break;
        case 4:
          this.order.deliveryPrice = this.deliveryPrices[
            this.order.deliveryType
          ];
          if (
            this.order.deliveryPrice !== 0 &&
            this.totalToPay - this.order.deliveryPrice <
              this.license.minToDelivery
          ) {
            this.deliveryCondition = false;
          }
          break;
      }
    },
    setReceiptType(rt) {
      this.receiptType = rt.typeClass;
      if (rt.typeClass == 2) {
        this.showInvoiceModal = true;
      }
    },
    setInvoiceData(customerData) {
      this.showInvoiceModal = false;
      let data =
        this.$anm22.strLang(this.lang, "Billing data", "Dati fatturazione") +
        "\n";
      data += customerData.name + "\n";
      data += "Via " + customerData.street + " " + customerData.number + "\n";
      data +=
        customerData.zip +
        " " +
        customerData.city +
        ", " +
        customerData.state +
        ", " +
        this.$anm22.tableClasses.worldCountry().getById(customerData.country)[
          this.lang
        ] +
        "\n";
      data += "C.F: " + customerData.taxCode + "\n";
      data += "P.IVA: " + customerData.vatNumber;
      data += "SDI: " + customerData.sdi;
      this.order.notes += data;
    },
    closeInvoiceModal() {
      this.showInvoiceModal = false;
      if (this.order.notes === "") {
        this.receiptType = 1;
      }
    },
    async handleAuthClose(result) {
      if (result) {
        // Load and check yb regs if yb is the selected payment method
        if (this.order.paymentMethod === 7) {
          const response = await this.$http.get("place-order/yb-regs");
          if (!response.data.error) {
            this.ybRegs = response.data.ybRegs;
          }
          if (!this.ybRegs.active) {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "No active Spiagge.it registration has been found with this account.",
                "Nessuna prenotazione Spiagge.it attiva è stata trovata per questo account."
              ),
              type: "alarm",
            });
            return;
          }
        }
        this.save();
      } else {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Log in or sign up error.",
            "C'è stato un errore in fase di accesso o registrazione."
          ),
          type: "alarm",
        });
        this.showLoginModal = false;
      }
    },
    async save() {
      // Verifica orario di consegna impostato (se impostato metodo di consegna diverso dal tavolo)
      if (this.order.deliveryType !== 5 && !this.order.deliveryTime) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "No delivery time selected",
            "Nessun orario di consegna selezionato"
          ),
          type: "alarm",
        });
        return;
      }
      // Verifica numero di telefono impostato (se impostato metodo di consegna diverso dal tavolo)
      if (this.order.deliveryType !== 5 && !this.order.deliveryData.phone) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "The phone number is mandatory",
            "Nessun numero di telefono inserito"
          ),
          type: "alarm",
        });
        return;
      }
      // Verifica spiaggia e ombrellone selezionati (se impostato metodo di consegna all'ombrellone)
      if (
        (this.order.deliveryType === 1 || this.order.deliveryType === 2) &&
        (!this.order.beach || !this.order.beachUmbrella)
      ) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Select beach and umbrella for delivery",
            "Selezionare spiaggia e ombrellone per la consegna"
          ),
          type: "alarm",
        });
        return;
      }
      // Verifica tavolo selezionato (se inpostato metodo di consegna al tavolo)
      if (this.order.deliveryType === 5 && !this.order.tableRef) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Select table for delivery",
            "Selezionare un tavolo per la consegna"
          ),
          type: "alarm",
        });
        return;
      }
      if (
        this.order.deliveryType === 7 &&
        (!this.order.deliveryData.name ||
          !this.order.deliveryData.street ||
          !this.order.deliveryData.number ||
          !this.order.deliveryData.city ||
          !this.order.deliveryData.zip ||
          !this.order.deliveryData.state ||
          !this.order.deliveryData.country ||
          !this.order.deliveryData.phone)
      ) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Delivery address invalid",
            "L'indirizzo di consegna non è stato compilato correttamente"
          ),
          type: "alarm",
        });
        return;
      }
      if (this.order.deliveryType === 9 && !this.order.pickUpPoint) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Select pick-up point for delivery",
            "Selezionare un punto di ritiro per la consegna"
          ),
          type: "alarm",
        });
        return;
      }
      if (
        this.order.deliveryType === 10 &&
        (!this.order.deliveryData.name ||
          !this.order.deliveryData.street ||
          !this.order.deliveryData.number ||
          !this.order.deliveryData.phone)
      ) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Delivery address invalid",
            "L'indirizzo di consegna non è stato compilato correttamente"
          ),
          type: "alarm",
        });
        return;
      }
      if (this.elements.length < 1) {
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "No elements in the cart!",
            "Nessun elemento nel carrello!"
          ),
          type: "alarm",
        });
        this.updating = false;
        return;
      }
      if (!this.user) {
        // Open user dialog
        this.showLoginModal = true;
        return;
      }
      this.updating = true;
      // Aggiunta tipo di scontrino desiderato
      if (this.order.notes !== "") {
        this.order.notes += "\n";
      }
      this.order.notes += "Ricevuta: " + this.receiptLabel;
      try {
        const response = await this.$http.post("place-order/save", {
          order: this.order,
          elements: this.elements,
          licenseCode: this.licenseSelected,
        });
        if (response.data.error && response.data.error !== "") {
          this.order.deliveryTime = "";
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "The time selected is not available, please try another one",
              "L'orario scelto non è disponibile, selezionarne un altro"
            ),
            type: "alarm",
          });
          this.updating = false;
          return;
        } else {
          await Promise.all([
            this.$store.dispatch("foodOrders/update", {
              vlf: this.$vlf("foodOrders"),
              objs: response.data.orders,
            }),
            this.$store.dispatch("foodOrderElements/update", {
              vlf: this.$vlf("foodOrderElements"),
              objs: response.data.orderElements,
              // Per pulire elementi cancellati dal db
              cleanFilters: [(e) => e.order === this.order.id],
            }),
          ]);
          // Apro la pagina di visualizzazione ordine
          this.$router
            .push("orders/" + response.data.orders[0].id + "?new=true")
            .catch((e) => console.log(e));
        }
      } catch (e) {
        //Messaggio offline - riprovare
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Offline! Go back online to complete the order",
            "Offline! Tornare online per completare l'ordine"
          ),
          type: "alarm",
        });
        this.updating = false;
      }
    },
    async loadPage() {
      const response = await this.$http.get("place-order");
      await Promise.all([
        this.$store.dispatch("foodLicenses/update", {
          vlf: this.$vlf("foodLicenses"),
          objs: [response.data.license],
        }),
        this.$store.dispatch("foodCategories/update", {
          vlf: this.$vlf("foodCategories"),
          objs: response.data.categories,
        }),
        this.$store.dispatch("foodProducts/update", {
          vlf: this.$vlf("foodProducts"),
          objs: response.data.products,
        }),
        this.$store.dispatch("foodRooms/update", {
          vlf: this.$vlf("foodRooms"),
          objs: response.data.rooms,
        }),
        this.$store.dispatch("foodTables/update", {
          vlf: this.$vlf("foodTables"),
          objs: response.data.tables,
        }),
        this.$store.dispatch("ybLicenses/update", {
          vlf: this.$vlf("ybLicenses"),
          objs: response.data.ybLicenses,
        }),
        this.$store.dispatch("works/update", {
          vlf: this.$vlf("works"),
          objs: response.data.works,
        }),
        this.$store.dispatch("places/update", {
          vlf: this.$vlf("places"),
          objs: response.data.places,
        }),
        this.$store.dispatch("workPlaceAssocs/update", {
          vlf: this.$vlf("workPlaceAssocs"),
          objs: response.data.workPlaceAssocs,
        }),
      ]);
      if (this.license) {
        // Verifico lo stile della pagina
        this.checkPageStyle();
        // Verifico se le ordinazioni sono attive
        if (
          !this.license.config.modules.delivery.enabled ||
          this.license.interrupted ||
          this.paymentMethods.length === 0
        ) {
          this.redirectToMenu();
          return;
        }
      } else {
        this.$router.push("/restaurants").catch((e) => console.log(e));
        return;
      }
      this.ybRegs = response.data.ybRegs;
      this.payCards = response.data.cards;
      /* Update order */
      const localId = this.$anm22.genLocalId();
      this.order = {
        id: localId,
        dbKey: localId,
        orderDate: "",
        lastModified: "",
        license: this.license.id,
        // createdBy: this.user.idWorldUser,
        // customer: this.user.idWorldUser,
        createdBy: "",
        customer: "",
        status: 3,
        estimatedTime: "",
        isPaying: false,
        payed: false,
        // id di pagamento valorizzato quando viene creato un pagamento che comprende il costo di consegna
        deliveryPayment: "",
        paymentMethod: "",
        paymentData: [],
        deliveryType: "",
        beach: "",
        beachUmbrella: "",
        tableRef: "",
        tableAlias: "",
        pickUpPoint: "",
        deliveryData: {
          country: "it",
        },
        deliveryTime: "",
        deliveryPrice: 0,
        surcharge: 0,
        discount: 0,
        totalVAT: 0,
        listTotal: 0,
        toPayTotal: 0,
        payedTotal: 0,
        receiptType: "",
        notes: "",
        printedSequence: 0,
        printedSequenceTime: "",
        // Array di id di pagamento (se 0 non è stato pagato) + prezzo dei coperti
        covers: [[], 0],
      };
      this.elements = [];
      //init
      this.setPaymentMethod(
        this.$anm22.tableClasses
          .worldPaymentModeType()
          .getById(this.paymentMethods[0])
      );
      this.setDeliveryType(
        this.$anm22.tableClasses
          .worldDeliveryType()
          .getById(this.deliveryTypes[0])
      );
      if (this.deliveryTypes.includes(5)) {
        if (this.$route.query.tableId) {
          const table = this.$store.getters["foodTables/get"](
            this.$route.query.tableId
          );
          if (table) {
            this.setDeliveryType(
              this.$anm22.tableClasses.worldDeliveryType().getById(5)
            );
            this.order.tableRef = table.id;
            this.deliveryBlocked = [5];
          }
        } else if (this.$route.query.tableName) {
          const table = this.$store.getters["foodTables/getByName"](
            this.$route.query.tableName
          );
          if (table) {
            this.setDeliveryType(
              this.$anm22.tableClasses.worldDeliveryType().getById(5)
            );
            this.order.tableRef = table.id;
            this.deliveryBlocked = [5];
          }
        }
      }
      // Selezione i dettagli di consegna se ci sono i parametri GET impostati
      if (
        this.$route.query.beachLicense &&
        this.$route.query.umbrella &&
        [1, 2].reduce(
          (res, dt) => res || this.deliveryTypes.includes(dt),
          false
        )
      ) {
        const beach = this.$store.getters["ybLicenses/getByYbLicense"](
          this.$route.query.beachLicense
        );
        if (beach) {
          this.order.beach = beach.beach;
          this.order.beachUmbrella = this.$route.query.umbrella;
          // Set delivery and block
          this.setDeliveryType(
            this.$anm22.tableClasses.worldDeliveryType().getById(1)
          );
          this.deliveryBlocked = [1, 2];
          if (
            this.$route.query.registration &&
            this.paymentMethods.includes(7)
          ) {
            this.setPaymentMethod(
              this.$anm22.tableClasses.worldPaymentModeType().getById(7)
            );
            this.order.paymentData = {
              beachId: beach.idWorldWork,
              umbrella: this.$route.query.umbrella,
              beachLicense: this.$route.query.beachLicense,
              registration: this.$route.query.registration,
            };
          }
        }
      } else {
        this.order.paymentData = {};
      }
      // Compilo i dati dei clienti se sono disponibili come parametro GET
      if (this.$route.query.name) {
        this.order.customerName = decodeURI(this.$route.query.name);
      }
      if (this.$route.query.surname) {
        this.order.customerSurname = decodeURI(this.$route.query.surname);
      }
      if (this.$route.query.email) {
        this.order.customerEmail = decodeURI(this.$route.query.email);
      }
      if (this.$route.query.phone) {
        this.order.customerPhone = decodeURI(this.$route.query.phone);
        this.order.deliveryData.phone = decodeURI(this.$route.query.phone);
      }
      // Controllo se ci sono registrazioni attive per i clienti
      if (this.ybRegs.active) {
        const registration = this.ybRegs.regs[0];
        const beach = this.$store.getters["ybLicenses/getByYbLicense"](
          registration.beachLicense
        );
        this.order.beach = beach.beach;
        this.order.beachUmbrella = registration.umbrella;
        this.setDeliveryType(
          this.$anm22.tableClasses.worldDeliveryType().getById(1)
        );
      }
      this.loading = false;
      this.$Progress.finish();
    },
    redirectToMenu() {
      let query = "";
      if (this.$route.query.license) {
        query = "?license=" + this.$route.query.license;
      }
      this.$router.push("/menu" + query).catch((e) => console.log(e));
    },
    checkPageStyle() {
      /** Club del Sole */
      const cdsIds = [32, 36, 37, 38, 39, 40, 42, 43, 44, 45, 46, 47, 97, 98, 133, 136, 137, 138, 139, 140, 141, 142, 143, 145, 151, 152, 153, 154, 155];
      if (typeof this.license !== "undefined") {
        if (cdsIds.includes(this.license.id)) {
          this.pageCustomCSS =
            "https://www.clubdelsole.com/upl/lp/yourFood/assets/clubdelsole.css";
          let file = document.createElement("link");
          file.rel = "stylesheet";
          file.href = this.pageCustomCSS;
          document.head.appendChild(file);
        }
      }
    },
  },
  created() {
    document.title = this.$anm22.strLang(
      this.lang,
      "New order",
      "Nuovo ordine"
    );
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "New order", "Nuovo ordine")
    );
    this.checkPageStyle();
    this.loadPage();
  },
  watch: {
    elements(newVal) {
      this.checkDeliveryCondition();
    },
    cartOpen(newVal) {
      if (this.defaultBackHref === "") {
        if (newVal) {
          this.$store.dispatch("headbar/setBackHref", "/");
        } else {
          this.$store.dispatch("headbar/setBackHref", "");
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("headbar/addButtons", [
      {
        mobileHide: false,
        img: this.$anm22.icons.getWorldIcon("shoppingCart"),
        offlineImg: this.$anm22.icons.getWorldIcon("shoppingCart"),
        title: this.$anm22.strLang(this.lang, "Cart", "Carrello"),
        style: "width:30px;height:30px;",
        class: "header-cart-btn",
        id: "header-cart-btn",
        visibility: "public",
        clickFn: () => {
          this.openCart();
        },
      },
    ]);
    // if (navigator.geolocation) {
    //   //Prende la posizione e richiama la funzione centerMap con le coordinate appena trovate
    //   navigator.geolocation.getCurrentPosition(
    //     pos => {
    //       // Wait for the map to be loaded before setting center
    //       this.$refs.mapRef.$mapPromise.then(map => {
    //         map.setCenter({
    //           lat: pos.coords.latitude,
    //           lng: pos.coords.longitude
    //         });
    //         map.setZoom(15);
    //       })
    //       .catch(e => console.log(e));
    //     },
    //     err => {
    //       console.log(err.message);
    //     },
    //     { enableHighAccuracy: true }
    //   );
    // }
  },
  beforeDestroy() {
    if (this.pageCustomCSS) {
      document
        .querySelectorAll("link[href='" + this.pageCustomCSS + "']")
        .forEach(function(e) {
          e.parentElement.removeChild(e);
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.fullPath === "/" && this.cartOpen) {
      this.closeCart();
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.cart {
  border-left: 1px solid #ccc;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}
.articles-div {
  background-color: #fff;
  padding: 10px;
}
input.full {
  width: 100%;
  max-width: 100%;
}
.action-btn {
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 0 0 2px #ccc;
  padding: 10px;
  cursor: pointer;
  height: 50px;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 1%;
  &.selected {
    box-shadow: 0 0 0 2px #2196f3;
  }
  &.disabled {
    cursor: default;
    opacity: 0.4;
    pointer-events: none;
  }
  &:hover {
    box-shadow: 0 0 0 2px #2196f3;
  }
}
.cover {
  height: 200px;
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.card {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  padding: 5px 10px;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.info {
  position: sticky;
  top: -1px;
  z-index: 100;
  // height: 70px;
}
.elements-counter {
  font-size: 20px;
  margin-right: 5px;
}
.menu {
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.error {
  background: #ffd740;
  border-radius: 5px;
  padding: 5px;
}
.hours {
  height: 25px;
  flex-wrap: nowrap;
  align-items: center;
}
@media screen and (max-width: 921px) {
  .card {
    border-bottom: 1px solid #ccc;
  }
}
// Transition hours div
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.cart-counter-button {
  width: 60px;
  height: 50px;
  border: 0;
  border-radius: 5px;
  margin-left: 5px;
  border-radius: 50%;
  cursor: pointer;

  .elements-counter {
    background-color: #dfe1e6;
    color: #172b4d;
    font-weight: bold;
    font-size: 11px;
    border-radius: 8px;
    padding: 3px;
    box-sizing: border-box;
    width: 30px;
    text-align: center;
  }
}
</style>
